export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-footer/index.ts